module.exports = __webpack_public_path__ + "static/img/videoInit.8e9514e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videoInit.png
// module id = Be/w
// module chunks = 0